export class UpdatePscEndpointInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fqdn",
            "baseName": "fqdn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdatePscEndpointInput.attributeTypeMap;
    }
    constructor() {
    }
}
